'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCardGiftcard = function MdCardGiftcard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 23.4v-10h-8.6l3.6 4.6-2.8 2q-5-6.8-5.6-7.7-0.6 0.9-5.6 7.7l-2.8-2 3.6-4.6h-8.6v10h26.8z m0 8.2v-3.2h-26.8v3.2h26.8z m-18.4-25q-0.7 0-1.2 0.5t-0.4 1.3 0.4 1.1 1.2 0.5 1.2-0.5 0.4-1.1-0.4-1.3-1.2-0.5z m10 0q-0.7 0-1.2 0.5t-0.4 1.3 0.4 1.1 1.2 0.5 1.2-0.5 0.4-1.1-0.4-1.3-1.2-0.5z m8.4 3.4q1.4 0 2.3 1t0.9 2.4v18.2q0 1.4-0.9 2.4t-2.3 1h-26.8q-1.4 0-2.3-1t-0.9-2.4v-18.2q0-1.4 0.9-2.4t2.3-1h3.7q-0.3-1.1-0.3-1.6 0-2.1 1.5-3.6t3.5-1.4q2.6 0 4.1 2.1l0.9 1.2 0.9-1.2q1.5-2.1 4.1-2.1 2 0 3.5 1.4t1.5 3.6q0 0.5-0.3 1.6h3.7z' })
        )
    );
};

exports.default = MdCardGiftcard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/card-giftcard.js
// module id = 2676
// module chunks = 0